<template>
  <div>
    <Menu />

    <section>
      <div class="container-fluid g-0 pt-3">
        <div class="row g-0">
          <div class="col text-center">
            <div class="developments-banner">
              <div class="row">
                <div class="col-lg-6 mx-auto align-self-center switch-white pb-5">
                  <h1 class="display-2 pb-5">New Developments</h1>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- AVEC LA TERRE -->
    <section class="mb-5">
      <div class="container g-5">
        <div class="row pt-5">
          <div class="col-md-12 pb-5 text-center">
            <p>Introducing</p>
            <h2>Avec la Terre</h2>
            <p class="text-black">Discover the epitome of luxury living at our exceptional lifestyle estate, where comfort, sustainability, privacy and nature intertwine. Indulge in an unparalleled lifestyle that cherishes ecological balance, while enjoying the finest amenities and breath-taking natural surroundings.</p>
          </div> 
          <div class="col-md-4 text-center pb-5">
            <img src="/images/outside-view.jpeg" class="img img-fluid">
          </div>
          <div class="col-md-4 text-center pb-5">
            <img src="/images/lounge-view.jpeg" class="img img-fluid">
          </div>
          <div class="col-md-4 text-center pb-5">
            <img src="/images/bedroom.jpeg" class="img img-fluid">
          </div>   
        </div>
      </div>
      <center><a type="button" class="btn cta-btn m-1" data-bs-toggle="modal" data-bs-target="#downloadModal">Download Brochure</a></center>
    </section>

    <!-- LA LUC -->
    <section class="mb-5">
      <div class="container g-5">
        <div class="row pt-5">
          <div class="col-md-12 pb-5 text-center">
            <p>Introducing</p>
            <h2>La Luc</h2>
            <p class="text-black">Welcome to La Luc - an elegant new retirement estate in the heart of Franschhoek, where refined living meets mountain and vineyard views. With full approvals secured and civil works starting January 2026, La Luc offers modern freehold homes, a full-service clubhouse, on-site frail care, and the freedom of an independent lifestyle. Priced from , R7,246,000.00 Vat Incl, this landmark development is Franschhoek’s first in over a decade.</p>
          </div> 
          <div class="col-md-4 text-center pb-5">
            <img src="/images/ll-1.jpg" class="img img-fluid">
          </div>
          <div class="col-md-4 text-center pb-5">
            <img src="/images/ll-2.jpg" class="img img-fluid">
          </div>
          <div class="col-md-4 text-center pb-5">
            <img src="/images/ll-3.jpg" class="img img-fluid">
          </div>   
        </div>
      </div>
      <center><a type="button" class="btn cta-btn m-1" data-bs-toggle="modal" data-bs-target="#downloadModalLaLuc">Download Brochure</a></center>
    </section>

    <!-- HUGUENOT ESTATE -->
    <!-- <section class="bg-light mt-5 mb-5 pb-5">
      <div class="container g-5">
        <div class="row pt-5">
          <div class="col-md-12 pb-5 text-center">
            <p>Introducing</p>
            <h2>Huguenot Estate</h2>
            <p class="text-black">Nestled in the heart of the Paarl Winelands, Huguenot Estate offers an exclusive collection of contemporary three-bedroom homes on full-title plots ranging from 200 m² to 400 m². Designed for modern living, each home is set within a beautifully landscaped and secure environment, where lifestyle and peace of mind come standard.</p>
            <p class="text-black">Residents can enjoy thoughtfully curated amenities, including a sparkling communal pool, scenic walking trails, and a versatile multi-sport court – all fostering a sense of community and well-being. Perfectly positioned just off the N1 corridor, the estate provides seamless access to Cape Town, world-renowned wine routes, and everyday conveniences. Blending modern architecture with sustainable design and a strong focus on family living, Huguenot Estate redefines Winelands living for those who seek both sophistication and comfort.</p>
          </div> 
          <div class="col-md-4 text-center pb-5">
            <img src="https://luxurywinelandsestates.co.za/images/huguenotestate_main.jpg" class="img img-fluid">
          </div>
          <div class="col-md-4 text-center pb-5">
            <img src="https://luxurywinelandsestates.co.za/images/huguenotestate_1.jpg" class="img img-fluid">
          </div>
          <div class="col-md-4 text-center pb-5">
            <img src="https://luxurywinelandsestates.co.za/images/huguenotestate_pool.jpg" class="img img-fluid">
          </div>   
        </div>
      </div>
      <center>
        <a class="btn cta-btn m-1" href="#contactform">
          Contact Us
        </a>
      </center>
    </section> -->

    <!-- DRAKENZICHT -->
    <section class="bg-light mt-5 mb-5 pb-5">
      <div class="container g-5">
        <div class="row pt-5">
          <div class="col-md-12 pb-5 text-center">
            <p>Introducing</p>
            <h2>Drakenzicht</h2>
            <p class="text-black">Life is beautiful at Drakenzicht Estate. Nestled within the Klein Drakenstein mountains in Paarl, one of the Cape’s most beautiful areas, this luxury “green” estate seamlessly blends beautiful natural scenery with secure family estate living. Eco-friendly and luxurious, Drakenzicht assures residents that they can enjoy safe, modern living in an idyllic location.</p>
          </div> 
          <div class="col-md-4 text-center pb-5">
            <img src="/images/dk-1.jpg" class="img img-fluid">
          </div>
          <div class="col-md-4 text-center pb-5">
            <img src="/images/dk-2.jpg" class="img img-fluid">
          </div>
          <div class="col-md-4 text-center pb-5">
            <img src="/images/dk-3.jpg" class="img img-fluid">
          </div>   
        </div>
      </div>
      <center><a type="button" class="btn cta-btn m-1" data-bs-toggle="modal" data-bs-target="#downloadModalDrakenzicht">Download Brochure</a></center>
    </section>

    <div class="container-fluid py-3" style="background-color: #255699; margin-top: 1rem;">
      <div class="row p-2 justify-content-center">
        <div class="col-md-6 p-4">
          <h2 class="text-white">The Winelands Awaits</h2>
          <p class="text-white">
            Contact us at
            <a class="text-white" href="mailto:admin.valdevie@everitt.co.za">admin.valdevie@everitt.co.za</a> or
            <a class="text-white" href="tel:+27832581212">+27 83 258 1212</a> or fill out the form below.
          </p>
          <ContactForm />
        </div>
      </div>
    </div>

    <Footer />
  </div>
</template>

<script>

import Menu from '@/components/Menu.vue'
import Footer from '@/components/Footer.vue'
import ContactForm from '@/components/ContactForm.vue'

export default {
  components: {
    Menu, Footer , ContactForm
  },
  mounted() {
  },
  data() {
    return {
      data: {
        listings: []
      },
      showContactForm: false
    }
  },
  methods: {

  }
}
</script>